import { useEffect, useState } from 'react';
import { DistributionClient } from '../lib/api';
import { useAuth } from '../lib/authContext';
import { supportedLocales } from '../lib/i18n';
import { useI18n } from '../lib/use-i18n';
import type { Locale } from '../lib/types';
import { AuthView } from './AuthView';

export function AccountView({ locale, onLocaleChange, client, audioLanguage, onAudioLanguageChange }: { locale: Locale; onLocaleChange: (locale: Locale) => void; client: DistributionClient | null; audioLanguage: string; onAudioLanguageChange: (code: string) => void }) {
  const { session, signOut } = useAuth();
  const { localeTag, t } = useI18n();

  const [languages, setLanguages] = useState<Array<{ code: string; name: string }>>([]);
  useEffect(() => {
    let active = true;
    void client?.audioLanguages().then(rows => { if (active) setLanguages(rows); }).catch(() => {});
    return () => { active = false; };
  }, [client]);

  if (!session) return <AuthView />;

  return (
    <section className="account-view">
      <div className="account-card glass-panel">
        <header><h2>{t('account')}</h2><span className="account-status"><i />{t('connected')}</span></header>
        <div className="account-details">
          <div className="account-row"><small>{t('email')}</small><span>{session.email}</span></div>
          <div className="account-row"><small>{t('role')}</small><span>{session.role}</span></div>
          <div className="account-row"><small>{t('userId')}</small><code>{session.uid}</code></div>
          <div className="account-row"><small>{t('deviceId')}</small><code>{session.deviceId}</code></div>
          <div className="account-row"><small>{t('sessionUntil')}</small><span><time dateTime={new Date(session.expiresAt).toISOString()}>{new Date(session.expiresAt).toLocaleString(localeTag)}</time></span></div>
        </div>
        <label className="account-language"><span>{t('language')}</span><select data-focusable="true" value={locale} onChange={(event) => onLocaleChange(event.target.value as Locale)}>{supportedLocales.map((item) => <option key={item.code} value={item.code}>{item.label}</option>)}</select></label>
        <label className="account-language"><span>{t('audio')}</span><select data-focusable="true" value={audioLanguage} disabled={!languages.length} onChange={event => onAudioLanguageChange(event.target.value)}>{languages.map(item => <option key={item.code} value={item.code}>{item.name}</option>)}</select></label>
        <button className="secondary-action account-signout" data-focusable="true" type="button" onClick={() => void signOut()}>{t('signOut')}</button>
      </div>
    </section>
  );
}
